import api from './axiosConfig';

// Call backend addLog to add a log entry, with SN, log_info, log_type, and log_date
export const addLog = async (logData) => {
  try {
    const response = await api.post('/logs/addLog', logData);
    return response.data;
  } catch (error) {
    console.error('Error adding log:', error.response?.data || error.message);
    throw error;
  }
};

// Call backend getAllLogs to get all logs for a specific capsule
export const getAllLogs = async (SN) => {
  try {
    console.log("Frontend SN is", SN);
    const response = await api.get('/logs/getAllLogs', {
      params: { SN }
    });
    console.log("Frontend all logs are ", response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching all logs:', error.response?.data || error.message);
    throw error;
  }
};




